var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#DAE4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6805 16.7201H14.4205V20.7701C14.4205 21.3701 15.1605 21.6501 15.5605 21.2001L19.8205 16.3601C20.1905 15.9401 19.8905 15.2801 19.3305 15.2801H17.5905V11.2301C17.5905 10.6301 16.8505 10.3501 16.4505 10.8001L12.1905 15.6401C11.8205 16.0601 12.1205 16.7201 12.6805 16.7201Z",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 26C21.4936 26 25.9707 21.5228 25.9707 16C25.9707 10.4772 21.4936 6 15.9707 6C10.4479 6 5.9707 10.4772 5.9707 16C5.9707 21.5228 10.4479 26 15.9707 26Z",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionStep);
export default __webpack_public_path__ + "static/media/action-step.68cba968039af1de4f736092a12acf58.svg";
export { ForwardRef as ReactComponent };